<template>
  <InviteTeammatesForm>
    <template #progress-bar>
      <CompleteSignupProgressRegular :currentStep="3" />
    </template>
  </InviteTeammatesForm>
</template>

<script>
import { isConfirmTokenPresent, showSessionExpiredWarning } from '@utils/confirmationToken'
import InviteTeammatesForm from '@components/sign-up/InviteTeammatesForm.vue'
import CompleteSignupProgressRegular from '@components/sign-up/complete-signup-progress/CompleteSignupProgressRegular.vue'

export default {
  name: 'InviteTeammates',
  components: {
    InviteTeammatesForm,
    CompleteSignupProgressRegular
  },
  mounted () {
    // Show warning message on page load if no confirmation cookie
    if (!isConfirmTokenPresent(this.$cookies)) {
      showSessionExpiredWarning(this)
    }
  }
}
</script>
